// frontend/klaes-app/src/components/FilmFavs/components/RatingPopup.jsx
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { FiX, FiCheck } from 'react-icons/fi';
import { BatteryIndicator } from './BatteryIndicator';
import styles from '../FilmFavs.module.css';

export const RatingPopup = ({ onRate, onClose, currentRating }) => {
  const [tempRating, setTempRating] = useState(currentRating ?? 50);

  return createPortal(
    <div
      className={styles.ratingPopupOverlay}
      role="presentation"
      onClick={onClose}
    >
      <div
        className={styles.ratingPopup}
        role="dialog"
        aria-modal="true"
        aria-labelledby="rating-popup-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.ratingPopupHeader}>
          <span id="rating-popup-title">Deine Bewertung bearbeiten</span>
          <button
            onClick={onClose}
            className={styles.ratingPopupCloseBtn}
            aria-label="Schließen"
          >
            <FiX />
          </button>
        </div>
        <input
          type="range"
          min="0"
          max="100"
          step="0.1"
          value={tempRating}
          onChange={(e) => setTempRating(parseFloat(e.target.value))}
          className={styles.ratingSlider}
        />
        <div className={styles.ratingValue}>{tempRating.toFixed(1)}%</div>
        <BatteryIndicator rating={tempRating} isUserRating />
        <button onClick={() => onRate(tempRating)} className={styles.ratingSubmit}>
          <FiCheck /> Bewertung aktualisieren
        </button>
      </div>
    </div>,
    document.body
  );
};